import useStorage, { getStorageItem, setStorageItem, deleteStorageItem } from '../../useStorage/useStorage'

export { getStorageItem, setStorageItem, deleteStorageItem }
export default useStorage
